import { TAppThunkDispatch, TGetState } from '~/src/store';

import { setTransactions, TPaymentTransaction } from '../actionCreators';

const updateTransaction = ({
    id,
    payed,
}: TPaymentTransaction) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const {
            payment: { transactions },
        } = getState();

        const index = transactions.findIndex(transaction => transaction.id === id);

        if (~index) {
            const payload = transactions.slice();

            payload.splice(index, 1, {
                id,
                payed,
            });
            dispatch(setTransactions(payload));
        }
    };
};

export default updateTransaction;
